import { createContext, useContext } from 'react';

/**
 * Teacher Check state for the owner's My Draft. The default is null, and every
 * consumer (FeedbackHeader, CommentCard32, DraftScoreChip via FeedbackHeader,
 * StudentPlanUpgradePopup) renders exactly as before when it is null — which is
 * always the case with the build flag off, outside a My Draft, or for anyone
 * who isn't an eligible free individual student.
 */
export const TeacherLoopContext = createContext(null);

export const useTeacherLoop = () => useContext(TeacherLoopContext);
